import { storableError } from '../../util/errors';
import {
  FETCH_PUBLIC_WISHLIST_REQUEST,
  FETCH_PUBLIC_WISHLIST_SUCCESS,
  FETCH_PUBLIC_WISHLIST_ERROR,
  loadPublicWishlistBySlug,
} from '../../ducks/wishlists.duck';

// ================ Reducer ================ //

const initialState = {
  wishlist: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_PUBLIC_WISHLIST_REQUEST:
      return {
        ...state,
        wishlist: null,
        fetchInProgress: true,
        fetchError: null,
      };

    case FETCH_PUBLIC_WISHLIST_SUCCESS:
      return {
        ...state,
        wishlist: payload,
        fetchInProgress: false,
      };

    case FETCH_PUBLIC_WISHLIST_ERROR:
      return {
        ...state,
        fetchInProgress: false,
        fetchError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators are in wishlists.duck.js ================ //
// ================ Thunks are in wishlists.duck.js ================ //

export const loadData = (params, search, config) => dispatch => {
  const { slug } = params;
  return dispatch(loadPublicWishlistBySlug(slug, config));
};
